const KEYS = {
  THEME: 'na_theme',
  SIDEBAR_COLLAPSED: 'na_sidebar_collapsed',
} as const;

export type ThemeMode = 'dark' | 'light';

export const localStorage = {
  getTheme(): ThemeMode {
    return (window.localStorage.getItem(KEYS.THEME) as ThemeMode) || 'dark';
  },

  setTheme(theme: ThemeMode): void {
    window.localStorage.setItem(KEYS.THEME, theme);
  },

  getSidebarCollapsed(): boolean {
    return window.localStorage.getItem(KEYS.SIDEBAR_COLLAPSED) === 'true';
  },

  setSidebarCollapsed(collapsed: boolean): void {
    window.localStorage.setItem(KEYS.SIDEBAR_COLLAPSED, String(collapsed));
  },
};
